import React from "react";
import PropTypes from "prop-types";

const Holidays = ({ holidayObj }) => {
  //region holidays colors
  const formatHolidayDate = (dateStr) => {
    const date = new Date(dateStr);

    // Extract individual parts using options
    const weekday = new Intl.DateTimeFormat("en-US", {
      weekday: "long",
    }).format(date);
    const month = new Intl.DateTimeFormat("en-US", { month: "short" }).format(
      date
    );
    const day = new Intl.DateTimeFormat("en-US", { day: "numeric" }).format(
      date
    );

    // Wrap in a container to prevent commas
    return (
      <div>
        <div className="d-flex align-items-center justify-content-evenly">
          <div className="fw-bold ">{month.toUpperCase()}</div>
          <div className="fw-bold ">{day}</div>
        </div>
        <div className="">{weekday}</div>
      </div>
    );
  };
  const colors = [
    "primary",
    "secondary",
    "warning",
    "info",
    "danger",
    "success",
  ];

  return (
    <div>
      <style>
        {`
        @media (max-width: 576px) {
          #offcanvasRightHolidays {
            width: 90% !important;
          }
        }

        @media (min-width: 577px) and (max-width: 992px) {
          #offcanvasRightHolidays {
            width: 45% !important;
          }
        }

        @media (min-width: 993px) and (max-width: 1440px) {
          #offcanvasRightHolidays {
            width: 22% !important;
          }
        }
          
        @media (min-width: 1441px)  {
          #offcanvasRightHolidays {
            width: 10% !important;
          }
        }
        `}
      </style>
      <div className="offcanvas offcanvas-end" id="offcanvasRightHolidays">
        <div className="offcanvas-header">
          <h4>
            <i className="fa-solid fa-gifts me-2"></i>Holidays
          </h4>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
          />
        </div>
        <div className="offcanvas-body">
          {Array.isArray(holidayObj) && holidayObj.length > 0 ? (
            holidayObj.map((item, index) => (
              <div
                className="card d-flex flex-row align-items-center p-1 mb-2 border hover-shadow"
                key={index}
              >
                <div
                  className={`text-center bg-${
                    colors[index % colors.length]
                  } text-white p-2 rounded`}
                  style={{ width: "6rem" }}
                >
                  {formatHolidayDate(item.HolidayDt)}
                </div>
                <div className="ms-3">
                  <h6 className="fw-bold mb-0">
                    {item?.Reason ? item.Reason : "No Reason Available"}
                  </h6>
                  {item?.Optional && (
                    <span className="badge bg-success ms-2 badge-xs">
                      Optional
                    </span>
                  )}
                </div>
              </div>
            ))
          ) : (
            <div className="d-flex justify-content-center">
              <span className="text-gray-400 fw-bold">No holidays found.</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
Holidays.propTypes = {
  holidayObj: PropTypes.object.isRequired,
};
export default Holidays;
